export default __webpack_public_path__ + "static/media/ic_map_asia.9b10965e.svg";